module.exports = __webpack_public_path__ + "img/map_google_ru.99737f28.jpg";